<template>
	<div>
		<breadcrumbs />

		<loading :active.sync="isLoading"></loading>

		<div class="content-i">
			<div class="content-box">
				<div class="row pt-4">
					<div class="col-sm-12">
						<!--START - User List -->
						<div class="element-wrapper">
							<h6 class="element-header capitalize">
								{{ t.user.list }}
							</h6>
							<div class="element-box-tp">
								<a v-on:click="createUser" class="mr-2 mb-2 btn btn-outline-primary"><i class="icon-plus"></i> {{ t.create_user }}</a>

								<div class="alert" v-if="status > 200">
								<span v-if="status == 401">
									{{ t.error.access_denied_content }}
								</span>
									<span v-if="status == 404">
									{{ t.error.notfound_content_list }}
								</span>
								</div>
								<!--------------------
				                START - Pipeline
				                -------------------->
								<div class="pipeline white lined-primary" v-if="w <= 700">
									<div class="pipeline-body">
										<div class="pipeline-item" v-for="user in users">
											<div class="pi-controls">
												<div class="pi-settings os-dropdown-trigger">
													<i class="os-icon os-icon-ui-46"></i>
													<div class="os-dropdown">
														<div class="icon-w">
															<i class="os-icon os-icon-ui-46"></i>
														</div>
														<ul>
															<li>
																<a href="#"><i class="os-icon os-icon-ui-49"></i><span>Edit Record</span></a>
															</li>
															<li>
																<a href="#"><i class="os-icon os-icon-grid-10"></i><span>Duplicate Item</span></a>
															</li>
															<li>
																<a href="#"><i class="os-icon os-icon-ui-15"></i><span>Remove Item</span></a>
															</li>
															<li>
																<a href="#"><i class="os-icon os-icon-ui-44"></i><span>Archive Project</span></a>
															</li>
														</ul>
													</div>
												</div>
												<div class="status status-green" data-placement="top" data-toggle="tooltip" title="Active Status"></div>
											</div>
											<div class="pi-body">
												<div class="avatar">
													<img alt="" :src="api+'api/v1/users/get/profile_pic/'+user.id">
												</div>
												<div class="pi-info">
													<div class="h6 pi-name">
														{{ user.firstName }} {{ user.lastName }} @ {{ user.username }}
													</div>
													<div class="pi-sub">
														{{ user.group.name }}
													</div>
												</div>
											</div>
											<div class="pi-foot">
												<div class="tags">
													<span class="tag" href="#">{{ t.user.created_at }}: {{ user.createdAt | timeAgo }}</span>
													<span class="tag" href="#">{{ t.user.last_login }}: {{ user.lastLogin | timeAgo }}</span>
												</div>
												<span class="extra-info" href="#">
												<router-link v-tooltip="t.user.manage" :to="{ name: 'users', query: $route.query, params: {id: user.id} }">
													<i class="dashicons dashicons-edit"></i>
												</router-link>
													<router-link :to="{name: 'userprofile', params: {id: user.id}}" v-tooltip="t.user.view.profile"><i class="dashicons dashicons-admin-users"></i></router-link>
													<a class="danger" href="#" v-tooltip="t.user.delete"><i class="dashicons dashicons-dismiss"></i></a>
												</span>
											</div>
										</div>
									</div>
								</div>
								<!--------------------
								END - Pipeline
								-------------------->

								<table-component
										v-if="status == 200 && w >= 700"
										table-class="table table-padded"
										filter-input-class="form-control col-4 float-right rounded bright"
										:data="users"
										sort-by="id"
										sort-order="desc"
								>
									<template>
										<table-column show="id" label="#" cell-class="w50"></table-column>
										<table-column cell-class="w50">
											<template scope="row">
												<div style="font-size: 22px" v-tooltip="row.region.name">
													<flag :iso="row.nationality" :squared="false"/>
												</div>
											</template>
										</table-column>
										<table-column :label="t.user.username" cell-class="stringLimit w100">
											<template scope="row">
												<router-link :to="{ name: 'userprofile', params: {id: row.id} }">{{ row.username }}</router-link>
											</template>
										</table-column>
										<table-column show="fullName" :label="t.user.full_name" cell-class="w150">
											<template scope="row">
												<div class="user-with-avatar">
													<span><router-link :to="{ name: 'userprofile', params: {id: row.id} }">{{ row.fullName }}</a></router-link></span>
												</div>
											</template>
										</table-column>
										<table-column show="email" cell-class="w150">
											<template scope="row">
												<div class="user-with-avatar">
													<span>{{ row.email }}</span>
												</div>
											</template>
										</table-column>
										<table-column show="active" cell-class="w50 text-center">
											<template scope="row">
												<div class="status-pill green" v-if="row.enabled">
												</div>
											</template>
										</table-column>
										<table-column label="" :sortable="false" :filterable="false" cell-class="row-actions fs20 ">
											<template scope="row">
												<router-link :to="{name: 'conversation_new', params: {uid: row.id} }">
													<i class="os-icon os-icon-email-forward"></i>
												</router-link>
												<router-link v-tooltip="t.user.manage" :to="{ name: 'apps', query: $route.query, params: {id: row.id} }">
													<i class="dashicons dashicons-edit"></i>
												</router-link>
												<router-link :to="{name: 'userprofile', params: {id: row.id}}" v-tooltip="t.user.view.profile"><i class="dashicons dashicons-admin-users"></i></router-link>
												<a class="danger" href="#" v-tooltip="t.user.delete"><i class="dashicons dashicons-dismiss"></i></a>
											</template>
										</table-column>
									</template>
								</table-component>

								<paginate v-if="pagination.pageCount"
								          :page-count="pagination.pageCount"
								          :page-range="pagination.pageRange"
								          :force-page="(pagination.current-1)"
								          :margin-pages="2"
								          :click-handler="onChangePage"
								          :prev-text="t.previous"
								          :next-text="t.next"
								          :container-class="'pagination float-right'"
								          :page-class="'page-item'"
								          :page-link-class="'page-link'"
								          :prev-class="'page-item'"
								          :prev-link-class="'page-link'"
								          :next-class="'page-item'"
								          :next-link-class="'page-link'"
								>
								</paginate>
							</div>
						</div>
						<!--END - User List -->
					</div>
				</div>
			</div>
			<!--------------------
			START - Sidebar
			-------------------->
			<div class="content-panel compact">
				<div class="content-panel-close" v-on:click="controlPanel()">
					<i class="os-icon os-icon-close"></i>
				</div>
				<div class="element-wrapper">
					<div class="element-actions actions-only" v-b-toggle.filter variant="primary">
							<span class="when-opened">
								<i class="os-icon os-icon-minus-circle"></i>
							</span>
						<span class="when-closed">
								<i class="os-icon os-icon-plus-circle"></i>
							</span>
					</div>
					<h6 class="element-header" v-b-toggle.filter variant="primary">
						{{ t.filter.title }}
					</h6>
					<div class="element-box-tp">
						<b-collapse :visible="false" id="filter" class="mt-2">
							<filterGenerator :filter="filter"></filterGenerator>
						</b-collapse>
					</div>
				</div>

				<userWidget :collapsed="true" :title="t.user.last_login" :filter="{ per_page: 10, short: 'lastLogin', direction: 'desc', loginDate: {from: moment().utc().add(-30, 'm').format('YYYY-MM-DD HH:mm:ss'), to: moment().utc().format('YYYY-MM-DD HH:mm:ss')}}" />

				<userWidget :collapsed="true" :title="t.last_activity" :filter="{ per_page:10, short: 'lastActivityAt', direction: 'desc', activityDate: {from: moment().utc().add(-30, 'm').format('YYYY-MM-DD HH:mm:ss'), to: moment().utc().format('YYYY-MM-DD HH:mm:ss') } }" />

			</div>
			<!--------------------
			END - Sidebar
			-------------------->
		</div>

		<sweet-modal ref="umodal" v-on:close="closeUser" v-on:open="openUser" :overlay-theme="modalTheme" :modal-theme="modalTheme">

			<sweet-modal-tab :title="t.user.info" id="tab1">

				<template v-if="$root.oauth.accessToken">
					<div class="row">
						<div class="col-16">
							<account />
						</div>
					</div>
					<component v-if="$route.query.view" v-bind:is="views[$route.query.view].c"></component>
				</template>

				<span v-if="$root.oauth.status == 403">
					{{ t.error.access_denied_content }}
				</span>
			</sweet-modal-tab>

			<sweet-modal-tab title="Domains" id="tab2">
				<domainList :app="$route.params.id" v-if="$route.params.id" />
			</sweet-modal-tab>

			<sweet-modal-tab title="Affiliate" id="tab3">
				<Affiliate v-if="$route.params.id" :uid="new Number($route.params.id)" />
			</sweet-modal-tab>

		</sweet-modal>

		<sweet-modal ref="userCreateModal" v-on:open="openUser">
			<Registration />
		</sweet-modal>
	</div>
</template>

<script>

	import domainList from '@/components/app/domainList'
    import Affiliate from '@/components/user/affiliate/affiliate'
    import userGroups from '@/components/user/userGroups'
    import Registration from '@/components/user/registration'
    import Paginate from 'vuejs-paginate'
    import ContentPlaceholder from 'vue-content-placeholder'
    import VueSlideOut from 'vue-slideout-panel'
    import { TableComponent, TableColumn } from 'vue-table-component'
    import ProfilePic from '@/components/user/ProfilePic'
    import tableLoader from '@/components/ui/loader/tableLoader.vue'
    import spinalLoader from '@/components/ui/loader/spinalLoader.vue'
    import symForm from '@/components/form/symForm.vue'
    import filterGenerator from '@/components/form/filter'
    import userWidget from '@/components/user/widget/userWidget'
    import navigations from '@/components/user/widget/userEditNavigations'

    import roles from '@/components/user/roles'
    import account from '@/components/user/account/personalInformations'
    import bankAccounts from '@/components/user/account/bankAccountList'

    export default {
        name: 'appList',
        components: {
            'vue-slideout-panel': VueSlideOut, 'table-component': TableComponent,
            'table-column': TableColumn, ContentPlaceholder, Paginate, ProfilePic, tableLoader, symForm,
            spinalLoader, filterGenerator, userWidget, roles, account, navigations, bankAccounts, Registration,
            userGroups, Affiliate, domainList
        },
        data () {
            return {
                w: window.innerWidth,
                api: window.api,
                isLoading: false,
                status: 0,
                t: this.$root.t,
                users: null,
                userId: this.$route.params.id,
                gender: [
                    {name: 'male'},
                    {name: 'female'}
                ],
                regions: [],
                currencies: [],
                userGroup: [],
                breadcrumb: [],
                userOpened: false,
                userForm: null,
                formProcess: 0,
                filter: {},
                opt: {
                    region: {data: [], label: 'nationallity'},
                    userGroup: {data: [], label: 'name'}
                },
                formData: [],
                pagination : {},
                modalTheme: 'light',
                views:
                    {edit_personal_informations: { c: account },
                        bank_accounts: { c: bankAccounts }
                    },

            }
        },
        watch: {
            '$route.params.id' (o, n) {
                if (o) {
                    this.$refs.umodal.open();
                    this.getUserForm();
                    this.$refs.userCreateModal.close()
                }
            },
            '$route.query' () {
                this.fetchUsers();
            },
        },
        mounted () {

            this.$bus.$on('darkMode', (payload) => {
                this.modalTheme = (payload) ? 'dark' : 'light'
            });
            if(this.$route.params.id > 0) {
                this.$refs.umodal.open();
            }
            this.fetchUsers();
            this.fetchRegions();
            this.fetchUserGroup();
            this.fetchCurrencies();
        },
        methods: {
            filterFixture () {
                this.filter = {
                    model: {
                        page: 1,
                        phone: '',
                        uid: '',
                        username: '',
                        email: '',
                        gender: [],
                        group: [],
                        currencies: [],
                        is_deleted: '',
                        is_online: '',
                        registerDate: [],
                        activityDate: [],
                        loginDate: [],
                        region: [],
                        allTime: 0,
                        short: 'lastActivityAt',
                        direction: 'desc'
                    },
                    schema: {
                        groups: [
                            {
                                legend: 'Genel',
                                fields: [
                                    {
                                        type: "Telephone",
                                        label: this.t.user.mobile_phone,
                                        model: "phone",
                                        readonly: false,
                                        featured: false,
                                        disabled: false
                                    },
                                    {
                                        type: "User",
                                        inputType: "text",
                                        label: this.t.referrer,
                                        model: "referrer",
                                        readonly: false,
                                        featured: false,
                                        disabled: false
                                    },
                                    {
                                        type: "input",
                                        inputType: "number",
                                        label: this.t.user.id,
                                        model: "uid",
                                        readonly: false,
                                        featured: false,
                                        disabled: false
                                    },
                                    {
                                        type: "User",
                                        inputType: "text",
                                        label: this.t.user.username,
                                        model: "uid",
                                        readonly: false,
                                        featured: false,
                                        disabled: false
                                    },
                                    {
                                        type: "input",
                                        inputType: "email",
                                        label: this.t.user.email,
                                        model: "email",
                                        readonly: false,
                                        featured: false,
                                        disabled: false
                                    },
                                    {
                                        type: "checklist",
                                        label: this.t.region.title,
                                        model: "region",
                                        multi: true,
                                        required: false,
                                        multiSelect: true,
                                        values: this.regions,
                                        checklistOptions: {
                                            value: "id",
                                            name: "name"
                                        }
                                    },
                                    {
                                        type: "checklist",
                                        label: this.t.finance.currency,
                                        model: "currencies",
                                        multi: true,
                                        required: false,
                                        multiSelect: true,
                                        values: this.currencies,
                                        checklistOptions: {
                                            value: "id",
                                            name: "iso_code"
                                        }
                                    },
                                    {
                                        type: "checklist",
                                        label: this.t.user.gender,
                                        model: "gender",
                                        multi: true,
                                        required: false,
                                        multiSelect: true,
                                        values: this.gender,
                                        checklistOptions: {
                                            value: "name",
                                            name: "name"
                                        }
                                    },
                                    {
                                        type: "checklist",
                                        label: this.t.user.group,
                                        model: "group",
                                        multi: true,
                                        required: false,
                                        multiSelect: true,
                                        values: this.userGroup,
                                        checklistOptions: {
                                            value: "id",
                                            name: "group_name"
                                        }
                                    },
                                    {
                                        type: "switch",
                                        label: this.t.user.online,
                                        model: "is_online",
                                        readonly: false,
                                        featured: false,
                                        disabled: false,
                                        default: false
                                    },
                                    {
                                        type: "switch",
                                        label: this.t.user.is_deleted,
                                        model: "is_deleted",
                                        readonly: false,
                                        featured: false,
                                        disabled: false,
                                        default: false
                                    },
                                    {
                                        type: "Datepicker",
                                        class: 'test',
                                        label: this.t.user.created_at,
                                        model: "registerDate",
                                        readonly: false,
                                        featured: false,
                                        disabled: false,
                                        options: {
                                            not_before: null,
                                            clearable: true,
                                            range: true,
                                            firstDay: 1,
                                            format: 'YYYY-MM-DD',
                                            dataFormat: 'YYYY-MM-DD',
                                        }
                                    },
                                    {
                                        type: "Datepicker",
                                        class: 'test',
                                        label: this.t.user.last_login,
                                        model: "loginDate",
                                        readonly: false,
                                        featured: false,
                                        disabled: false,
                                        options: {
                                            not_before: null,
                                            clearable: true,
                                            range: true,
                                            firstDay: 1,
                                            format: 'YYYY-MM-DD',
                                            dataFormat: 'YYYY-MM-DD',
                                        }
                                    },
                                    {
                                        type: "Datepicker",
                                        class: 'test',
                                        label: this.t.last_activity,
                                        model: "activityDate",
                                        readonly: false,
                                        featured: false,
                                        disabled: false,
                                        options: {
                                            not_before: null,
                                            clearable: true,
                                            range: true,
                                            firstDay: 1,
                                            format: 'YYYY-MM-DD',
                                            dataFormat: 'YYYY-MM-DD',
                                        }
                                    },
                                    {
                                        type: "submit",
                                        label: "",
                                        buttonText: this.t.filter.title,
                                        onSubmit: this.filterNow,
                                        validateBeforeSubmit: false,
                                    }
                                ]
                            }
                        ],
                    },
                    options: {
                        validateAfterLoad: true,
                        validateAfterChanged: true
                    }
                }
            },
            onChangePage (page) {
                this.pagination.current = page;

                this.$route.query.page = page;
                var qr = this.$route.query;
                this.$router.push({});

                this.$router.push({ query: qr });


                window.scroll(0, 0);
            },
            filterNow: function() {
                var model = this.$route.query;
                this.$router.push({ query: {} });
                this.$router.push({ query: this.filter.model });
                window.scrollTo(0,0);
            },
            changeEditView (v) {
                this.$route.query.view = v;
                var qr = this.$route.query;
                this.$router.push({ query: {} });
                this.$router.push({ query: qr });
                window.scrollTo(0,0);
            },
            createUser () {
                this.$refs.userCreateModal.open()
            },
            openUser () {
                this.userOpened = true;
                this.createToken(this.$route.params.id);
            },
            closeUser () {
                this.userOpened = false;
                this.$route.query.view = null
                this.$route.query.access_token = null;
                this.$router.replace({ params: {id: null}, query: this.$route.query });
                setTimeout(() => { document.body.style.overflow='auto'; }, 500 );
            },
            getBackNavi () {
                this.$route.query.view = null
                this.$route.query.access_token = null;
                var q = this.$route.query;
                this.$router.push({});
                this.$router.push({ params: {id: this.$route.params.id}, query: q });
            },
            async fetchUserGroup () {

		        this.$http.get(api+'api/v1/users/groups/get/all')
		            .then(response => {

		            this.userGroup = response.body.result.groups;
		            this.filterFixture();
		        }, response => {

        })
    },
    async fetchRegions () {

        this.$http.get(api+'api/v1/regions')
            .then(response => {

            this.regions = response.body.result.regions;
        this.filterFixture();
    }, response => {

        })
    },
    async fetchCurrencies () {
        this.$http.get(api+'api/v1/currencies')
            .then(response => {

            this.currencies = response.body.result.currencies;
        this.filterFixture();
    }, response => {

        })
    },
    async fetchUsers (refresh = false) {

        if (!this.isLoading) {
            this.isLoading = true;
            this.$http.get(api+'api/v1/users?isApp=1',
                { params: this.$route.query })
                .then(response => {

                this.pagination = response.body.result.pagination;
                this.users =  Object.values(response.body.result.users);
                this.translation = response.body.translation;

                this.status = response.status;

                this.usersLazyLoad = false;
                this.isLoading = false;
            }, response => {
                this.isLoading = false;
                this.status = response.status;
            })
        }

    },
    async getUserForm (data) {

        if(this.$route.params.id) {
            this.userForm = null;
            this.formProcess = 0;

            if(data) {
                //this.userForm = null;
                this.$http.post(api+'api/v1/form/user/'+this.$route.params.id,
                    data )
                    .then(response => {

                    this.userForm = response.body.result;
                this.formProcess = 200;

                setTimeout( () => { this.formProcess = 0; }, 2000);

            }, response => {
                    this.userForm = response.body.result;
                    this.formProcess = 400;
                })

            } else {
                this.$http.get(api+'api/v1/form/user/'+this.$route.params.id)
                    .then(response => {

                    this.userForm = response.body.result;
                this.formData = response.body.form_data;
                this.opt.region.data = this.regions;
                this.opt.region.label = 'name'

                this.opt.userGroup.data = this.userGroup;
                this.opt.userGroup.label = 'group_name'

            }, response => {

                })
            }
        }
    }
    }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/user/appList.vue